import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There are two ways to implement feature flags in React Native:`}</p>
    <ol>
      <li parentName="ol">{`Using hooks.`}</li>
      <li parentName="ol">{`Loading the flag directly.`}</li>
    </ol>
    <h3 {...{
      "id": "method-1-using-hooks"
    }}>{`Method 1: Using hooks`}</h3>
    <h4 {...{
      "id": "example-1-boolean-feature-flags"
    }}>{`Example 1: Boolean feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`import { useFeatureFlag } from 'posthog-react-native'

const MyComponent = () => {
    const booleanFlag = useFeatureFlag('key-for-your-boolean-flag')

    if (showFlaggedFeature === undefined) {
        // the response is undefined if the flags are being loaded
        return null
    }

    return showFlaggedFeature ? <Text>Testing feature 😄</Text> : <Text>Not Testing feature 😢</Text>
}
`}</code></pre>
    <h4 {...{
      "id": "example-2-multivariate-feature-flags"
    }}>{`Example 2: Multivariate feature flags`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`import { useFeatureFlag } from 'posthog-react-native'

const MyComponent = () => {
    const multiVariantFeature = useFeatureFlag('key-for-your-multivariate-flag')

    if (multiVariantFeature === undefined) {
        // the response is undefined if the flags are being loaded
        return null
    } else if (multiVariantFeature === 'variant-name') { // replace 'variant-name' with the name of your variant
      // Do something
    }

    return <div/>
}
`}</code></pre>
    <h3 {...{
      "id": "method-2-loading-the-flag-directly"
    }}>{`Method 2: Loading the flag directly`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`// Defaults to undefined if not loaded yet or if there was a problem loading
posthog.getFeatureFlag('key-for-your-boolean-flag')

// Multivariant feature flags are returned as a string
posthog.getFeatureFlag('key-for-your-multivariate-flag')
`}</code></pre>
    <h3 {...{
      "id": "reloading-flags"
    }}>{`Reloading flags`}</h3>
    <p>{`PostHog loads feature flags when instantiated and refreshes whenever methods are called that affect the flag. `}</p>
    <p>{`If you have the need to forcefully trigger the refresh however you can use `}<inlineCode parentName="p">{`reloadFeatureFlagsAsync()`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`posthog.reloadFeatureFlagsAsync().then((refreshedFlags) => console.log(refreshedFlags))
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      